import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { Modal } from './Header/AddCampaignModal';
import { IoMdClose } from 'react-icons/io';
import { FormInputContainer } from './Header/FormInput';
import { useCampaignContext } from 'context/CampaignContext';
import DatePicker from 'react-datepicker';
import { DarkButton } from 'components/style/Global';
import { useState } from 'react';
import { SubContainer } from './Main/Summary/Summary';
import styled from 'styled-components';
import { SingleColumn } from 'components/newSetup/OVERWRITE_DATA/OverwriteMain.Styles';
import { CustomSelect } from 'components/Header/CampaignSelectComponent';
import {
  datatype,
  filtertype,
  SaveCustomReportMutation,
  SaveCustomReportMutationVariables,
  UpdateCustomReportMutationVariables,
} from 'API';
import { saveCustomReport, updateCustomReport } from 'graphql/mutations';
import { API } from 'aws-amplify';
import { red } from '@mui/material/colors';
import { getEndDate, getStartDate } from 'methods/dateMethods';
import { useCustomReportContext } from 'context/CustomReportContext';
import { useSaveNewSection } from './CustomReports/CustomReportsHooks/useCustomReportsGrid';
import { fetchCampaignsInDateRange } from './CustomReports/CustomReportsHooks/useCustomReportsQueries';
import { useLoggingActivity } from 'customHooks/useLogging';

type Props = {
  setAddCustomReportModal: (value: boolean) => void;
};

export type CampaignPeriodValues = {
  customReportName: string;
  startDate: string;
  endDate: string;
  clientCode?: string;
  campaigns?: string[];
  filterName?: string;
};

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const StyledLabel = styled.label`
  cursor: pointer;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  width: 100%;
  margin-bottom: 8px;
  /* margin-top: 21px; */
  font-family: 'FontMedium', sans-serif;
  color: ${({ theme }) => theme.primaryGray};
  display: flex;
  margin-bottom: 0.24vw;
  /* background-color: ${({ theme }) => theme.background}; */

  .inputCircle {
    display: none;
  }
  .checked {
    padding: 0.47vw 0.63vw;
    /* max-width: 14vw; */
    span {
      font-size: 0.73vw;
      font-family: 'FontMedium';
      font-weight: normal;
      color: ${({ theme }) => theme.primaryGray};
      word-wrap: break-word;
    }
    .styleToFit {
      font-size: 12px;
      font-family: 'fontRegular';
      width: 100%;
      z-index: 0;
    }
  }

  input:checked ~ .checked {
    /* border: 1px solid ${({ theme }) => theme.primaryGray}; */
    background-color: ${({ theme }) => theme.border};
    /* box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.primaryGray}; */
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 7px;
    width: 100%;
  }
`;

const FilterTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1vw;
  margin-top: 1vw;
  padding: 1vw;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.border};
`;

const AddCustomReport = (props: Props) => {
  const { setAddCustomReportModal } = props;
  const { activeCampaign, reducedClientList, permanentCampaignList } = useCampaignContext();
  const { activeCustomReport } = useCustomReportContext();
  const logActivity = useLoggingActivity();
  const activeCustomReportFilterType = activeCustomReport?.Filters?.[0]?.column === 'date' ? 'date' : 'campaigns';
  const activeCustomReportEditValuesObject =
    activeCustomReportFilterType === 'date'
      ? {
          customReportName: activeCustomReport?.CustomReportName || '',
          filterName: activeCustomReportFilterType,
          startDate: (activeCustomReport?.Filters?.[0]?.filter?.from as string) || '',
          endDate: (activeCustomReport?.Filters?.[0]?.filter?.to as string) || '',
          clientCode: activeCustomReport?.Client?.Code || '',
        }
      : {
          customReportName: activeCustomReport?.CustomReportName || '',
          filtertype: activeCustomReportFilterType,
          startDate: '',
          endDate: '',
          campaigns: (activeCustomReport?.Filters?.[0]?.filter?.list as string[]) || [],
          clientCode: activeCustomReport?.Client?.Code || '',
          filterName: activeCustomReportFilterType,
        };
  const [values, setValues] = useState<CampaignPeriodValues>(
    !activeCustomReport
      ? {
          customReportName: '',
          startDate: activeCampaign?.startDate as string,
          endDate: activeCampaign?.endDate as string,
        }
      : activeCustomReportEditValuesObject,
  );

  const handleSelectChangeAndUpdateGlobal = (selectedOption: any, accessorKey: string) => {
    const value = selectedOption ? (selectedOption.label ? selectedOption.label : selectedOption) : '';

    setValues({
      ...values,
      [accessorKey]: value,
    });
  };

  const campaignsWithSelectedClient = permanentCampaignList
    ?.filter((campaign) => campaign?.ClientCode === values.clientCode)
    .flatMap((campaign) =>
      campaign?.campaignId.toString().startsWith('100') ? (campaign?.childCampaigns ?? []) : [campaign],
    )
    .filter((campaign) => campaign && !campaign.campaignId.toString().startsWith('100'))
    .map((campaign) => ({ value: campaign?.campaignId, label: `${campaign?.campaign} (${campaign?.campaignId})` }));
  // console.log(campaignsWithSelectedClient);

  const [summaryToast, setSummaryToast] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [saveNewSection] = useSaveNewSection();

  // Validation function that checks for campaigns in date range before showing summary
  const validateAndProceed = async () => {
    setValidationError(null);

    // Basic validation
    if (values.customReportName === '') {
      setValidationError('Please enter a custom report name');
      return;
    }
    if (!values.clientCode) {
      setValidationError('Please select a client');
      return;
    }
    if (!values.filterName) {
      setValidationError('Please select filter type (Date period or Campaign list)');
      return;
    }

    if (values.filterName === 'date') {
      if (!values.startDate || !values.endDate) {
        setValidationError('Please select start and end date');
        return;
      }

      // Check if there are campaigns in the selected period
      setIsValidating(true);
      try {
        const selectedClientCountry = reducedClientList?.find(
          (client) => client?.ClientCode === values.clientCode,
        )?.ClientCountry;

        const campaigns = await fetchCampaignsInDateRange(
          values.clientCode || '',
          selectedClientCountry || '',
          values.startDate,
          values.endDate,
        );

        if (!campaigns || campaigns.length === 0) {
          setValidationError('No campaigns found in the selected period. Please change the date range.');
          setIsValidating(false);
          return;
        }
      } catch (error) {
        console.error('Error validating campaign period:', error);
        setValidationError('Error checking campaigns. Please try again.');
        setIsValidating(false);
        return;
      }
      setIsValidating(false);
    } else if (values.filterName === 'campaigns') {
      if (!values.campaigns || values.campaigns.length === 0) {
        setValidationError('Please select at least one campaign');
        return;
      }
    }

    // Validation passed, show summary
    setSummaryToast(true);
  };

  const saveReport = () => {
    const callAPI = async (filters: any) => {
      try {
        const response = (await API.graphql({
          query: saveCustomReport,
          variables: {
            Client: {
              Country: reducedClientList?.find((client) => client?.ClientCode === values.clientCode)?.ClientCountry,
              Code: values.clientCode,
            },
            CustomReportName: values.customReportName,
            Filters: [filters],
          } as SaveCustomReportMutationVariables,
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: SaveCustomReportMutation };
        if (response.data.saveCustomReport) {
          console.log('Custom report saved successfully:', response.data.saveCustomReport);
          const id = response.data.saveCustomReport;

          return { status: true, id: id };
        }
      } catch (e) {
        console.error('ERROR SAVING CUSTOM REPORT', e);
        return { status: false, id: null };
      }
    };

    if (values.customReportName === '') {
      alert('Please enter a custom report name');
      return;
    }
    if (values.filterName === 'date') {
      if (values.startDate === '' || values.endDate === '') {
        alert('Please select start and end date');
        return;
      } else {
        const filters = {
          column: 'date',
          filter: {
            filtertype: filtertype.BETWEEN,
            datatype: datatype.DATE,
            from: values.startDate,
            to: values.endDate,
          },
        };
        callAPI(filters).then((res) => {
          if (res?.status) {
            const newSection = {
              position: 1,
              sectionElements: [],
              sectionPosition: {
                i: '1',
                x: 0,
                y: 0,
                w: 1,
                h: 1,
              },
            };
            saveNewSection(newSection.position, newSection.sectionPosition, res.id as number).then((response) => {
              if (response === 'success') {
                setAddCustomReportModal(false);
                window.location.reload();
              }
            });
          } else {
            alert('Error saving custom report');
          }
        });
        return;
      }
    }
    if (values.filterName === 'campaigns') {
      if (values.campaigns === undefined || values.campaigns.length === 0) {
        alert('Please select at least one campaign');
        return;
      } else {
        const filters = {
          column: 'campaign_id',
          filter: {
            filtertype: filtertype.IN,
            datatype: datatype.STRING,
            list: values.campaigns,
          },
        };
        callAPI(filters).then((res) => {
          if (res?.status) {
            const newSection = {
              position: 1,
              sectionElements: [],
              sectionPosition: {
                i: '1',
                x: 0,
                y: 0,
                w: 1,
                h: 1,
              },
            };
            saveNewSection(newSection.position, newSection.sectionPosition, res.id as number).then((response) => {
              if (response === 'success') {
                setAddCustomReportModal(false);
                window.location.reload();
              }
            });
          } else {
            alert('Error saving custom report');
          }
        });
        return;
      }
    }
  };

  const editReport = () => {
    const callAPI = async (filters: any) => {
      try {
        const response = (await API.graphql({
          query: updateCustomReport,
          variables: {
            CustomReportID: activeCustomReport?.CustomReportID,
            CustomReportName: values.customReportName,
            Filters: [filters],
          } as UpdateCustomReportMutationVariables,
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: SaveCustomReportMutation };
        console.log('RESPONSE', response);
        return true;
      } catch (e) {
        console.error('ERROR SAVING CUSTOM REPORT', e);
        return false;
      }
    };

    if (values.filterName === 'date') {
      if (values.startDate === '' || values.endDate === '') {
        alert('Please select start and end date');
        return;
      } else {
        const filters = {
          column: 'date',
          filter: {
            filtertype: filtertype.BETWEEN,
            datatype: datatype.DATE,
            from: values.startDate,
            to: values.endDate,
          },
        };
        callAPI(filters).then((res) => {
          if (res) {
            setAddCustomReportModal(false);
            window.location.reload();
          } else {
            alert('Error saving custom report');
          }
        });
        return;
      }
    }
    if (values.filterName === 'campaigns') {
      if (values.campaigns === undefined || values.campaigns.length === 0) {
        alert('Please select at least one campaign');
        return;
      } else {
        const filters = {
          column: 'campaign_id',
          filter: {
            filtertype: filtertype.IN,
            datatype: datatype.STRING,
            list: values.campaigns,
          },
        };
        callAPI(filters).then((res) => {
          if (res) {
            setAddCustomReportModal(false);
            window.location.reload();
          } else {
            alert('Error saving custom report');
          }
        });
        return;
      }
    }
  };

  const handleSubmitClick = async () => {
    // Log the add custom report activity (only for new reports, not edits)
    if (!activeCustomReport) {
      logActivity({
        action: 'ADD_CUSTOM_REPORT',
      }).catch(console.error);
    }

    // Call the appropriate function based on whether it's edit or new
    if (activeCustomReport) {
      editReport();
    } else {
      saveReport();
    }
  };

  return (
    <Modal style={{ zIndex: 1000 }}>
      <HeadModul style={{ height: 'fit-content' }}>
        <button type="button" className="x" onClick={() => setAddCustomReportModal(false)}>
          {' '}
          <IoMdClose className="closeIcon" />
        </button>

        <h1>Add Custom Report</h1>
        {!summaryToast ? (
          <ModulContainer>
            {/* Text Input for Custom Report Name */}
            <FormInputContainer>
              <label htmlFor="customReportName">Custom Report Name</label>
              <input
                type="text"
                id="customReportName"
                name="customReportName"
                placeholder="Enter custom report name"
                style={{ width: '100%', padding: '0.5rem' }}
                value={values['customReportName'] || ''}
                onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'customReportName')}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck="false"
              />
            </FormInputContainer>

            {/* Client Code Dropdown */}
            <FormInputContainer>
              <label htmlFor="clientCode">Client Code</label>
              <select
                id="clientCode"
                name="clientCode"
                style={{ width: '100%', padding: '0.5rem' }}
                // value={values['clientCode'] || ''}
                value={values['clientCode'] || ''}
                onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'clientCode')}
              >
                <option disabled selected hidden value=""></option>
                {reducedClientList?.map((client) => (
                  <option key={client?.ClientCode} value={client?.ClientCode}>
                    {client?.ClientCode} {client?.ClientCountry} ({client?.ClientName})
                  </option>
                ))}
              </select>
            </FormInputContainer>

            <FormInputContainer>
              <label htmlFor="">Create Custom Report based on Date or Campaigns</label>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '1vw' }}>
                <StyledLabel>
                  <input
                    className="inputCircle"
                    type="radio"
                    name="filterName"
                    value={'date'}
                    checked={values.filterName === 'date'}
                    onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'filterName')}
                  />
                  <span className="checked">Date period</span>
                </StyledLabel>

                <StyledLabel>
                  <input
                    className="inputCircle"
                    type="radio"
                    name="filterName"
                    value={'campaigns'} //TODO
                    checked={values.filterName === 'campaigns'}
                    onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'filterName')}
                  />
                  <span className="checked">Campaign list</span>
                </StyledLabel>
              </div>

              {values.filterName === 'date' && (
                <FilterTypeContainer>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '3vw' }}>
                    <FormInputContainer style={{ width: 'fit-content' }}>
                      <label htmlFor="startDate">Start Date</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        dateFormat="dd-MM-yyyy"
                        selected={
                          Object.keys(values).some((key) => key === 'startDate')
                            ? values['startDate']
                            : new Date(activeCampaign?.startDate as string)
                        }
                        onChange={(selectedOption: any) =>
                          handleSelectChangeAndUpdateGlobal(selectedOption.toISOString().slice(0, 10), 'startDate')
                        }
                        calendarStartDay={1}
                        minDate={getStartDate()}
                        maxDate={getEndDate()}
                      />
                    </FormInputContainer>
                    <FormInputContainer style={{ width: 'fit-content' }}>
                      <label htmlFor="endDate">End Date</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        dateFormat="dd-MM-yyyy"
                        selected={
                          Object.keys(values).some((key) => key === 'endDate')
                            ? values['endDate']
                            : new Date(activeCampaign?.endDate as string)
                        }
                        onChange={(selectedOption: any) =>
                          handleSelectChangeAndUpdateGlobal(selectedOption.toISOString().slice(0, 10), 'endDate')
                        }
                        calendarStartDay={1}
                        minDate={new Date(activeCampaign?.startDate as string)}
                        maxDate={new Date(activeCampaign?.endDate as string)}
                      />
                    </FormInputContainer>
                  </div>
                </FilterTypeContainer>
              )}
              {values.filterName === 'campaigns' && (
                <FilterTypeContainer>
                  <FormInputContainer>
                    <label htmlFor="campaigns">Campaigns</label>
                    <SubContainer style={{ padding: '0.5rem', width: '90%' }}>
                      <CustomSelect
                        className="styleToFit"
                        placeholder={
                          !values.clientCode || campaignsWithSelectedClient?.length === 0
                            ? 'Select Client First'
                            : 'Select Campaign(s)'
                        }
                        isMulti
                        value={values.campaigns?.map((campaign) => ({ value: campaign, label: campaign })) || []}
                        options={campaignsWithSelectedClient}
                        onChange={(selectedOption: any) => {
                          const selectedValues = selectedOption.map((option: any) => option.value);
                          handleSelectChangeAndUpdateGlobal(selectedValues, 'campaigns');
                        }}
                        isDisabled={!values.clientCode || campaignsWithSelectedClient?.length === 0}
                      ></CustomSelect>
                    </SubContainer>
                  </FormInputContainer>
                </FilterTypeContainer>
              )}
            </FormInputContainer>

            {/* Validation Error Message */}
            {validationError && (
              <div
                style={{
                  padding: '.6rem',
                  borderRadius: '4px',
                  margin: '1rem 0',
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  border: '1px solid #f5c6cb',
                  textAlign: 'center',
                  fontSize: '0.9vw',
                }}
              >
                {validationError}
              </div>
            )}

            {/* Date Picker for Start Date and End Date */}

            <div className="buttonsContainer" style={{ alignSelf: 'center' }}>
              <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setAddCustomReportModal(false)}>
                Cancel
              </button>
              {activeCustomReport ? (
                <DarkButton type="button" disabled={isValidating} onClick={() => validateAndProceed()}>
                  {isValidating ? 'Checking...' : 'Edit'}
                </DarkButton>
              ) : (
                <DarkButton type="button" disabled={isValidating} onClick={() => validateAndProceed()}>
                  {isValidating ? 'Checking...' : 'Save'}
                </DarkButton>
              )}
            </div>
          </ModulContainer>
        ) : (
          <ModulContainer>
            <SingleColumn style={{ width: '100%', padding: '1.5rem' }}>
              <h1 style={{ fontSize: '1.2vw' }}>Summary</h1>
              {/* Custom Report Name */}
              <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                <strong>Custom Report Name:</strong> {values.customReportName || 'N/A'}
              </h1>

              {/* Client Code */}
              <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                <strong>Client Code:</strong> {values.clientCode || 'N/A'}
              </h1>

              {/* Date or Campaigns */}
              {values.filterName === 'date' ? (
                <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                  <strong>Date Period:</strong>
                  <div style={{ display: 'flex', gap: '2rem', marginTop: '0.5rem' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', display: 'block' }}>Start Date:</label>
                      {values.startDate || 'N/A'}
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', display: 'block' }}>End Date:</label>
                      {values.endDate || 'N/A'}
                    </div>
                  </div>
                </h1>
              ) : (
                <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                  <strong>Campaigns:</strong>
                  <div style={{ marginTop: '0.5rem' }}>
                    {values.campaigns && values.campaigns.length > 0
                      ? values.campaigns.map((campaign) => (
                          <span key={campaign} style={{ display: 'block' }}>
                            {campaign}
                          </span>
                        ))
                      : 'N/A'}
                  </div>
                </h1>
              )}
            </SingleColumn>
            <div className="buttonsContainer" style={{ alignSelf: 'center', marginTop: '2rem' }}>
              <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setSummaryToast(false)}>
                Edit
              </button>
              <DarkButton type="button" onClick={() => handleSubmitClick()}>
                Confirm & Submit
              </DarkButton>
            </div>
          </ModulContainer>
        )}
      </HeadModul>
    </Modal>
  );
};

export default AddCustomReport;
